require('../../modules/es6.string.raw');
module.exports = require('../../modules/_core').String.raw;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/string/raw.js
// module id = 736
// module chunks = 0